<div (click)="select()"
     [class.highlight-hover]="highlightHover"
     [class.highlight]="highlight"
     class="kt-option option-outline-brand">
    <span class="kt-option__label">
        <span class="kt-option__head">
            <span class="kt-option__title">{{label}}</span>
        </span>
    </span>
</div>